import { useI18n } from '../i18n/I18nProvider';

export default function StatCard({ title, value, accent = '', subtitle }) {
  const { formatNumber } = useI18n();
  const cls = ['uh-card', 'stat', accent].filter(Boolean).join(' ');
  const formatted = typeof value === 'number'
    ? formatNumber(value)
    : (value ?? '—');

  return (
    <div className={cls} role="group" aria-label={String(title)}>
      <div className="uh-card-title">{title}</div>
      <div className="uh-card-value">{formatted}</div>
      {subtitle && <div style={{ fontSize: 12, color: 'var(--subtext)', marginTop: 4 }}>{subtitle}</div>}
    </div>
  );
}
